import dayjs, { Dayjs } from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

import { SDate } from '@summit/core';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
dayjs.extend(isBetween);

export function RoundUpToMinute(combinedTime: number): number {
  const hours = Math.trunc(combinedTime);
  const partialHour = Number((combinedTime - Math.trunc(combinedTime)).toFixed(4));
  if (combinedTime == 12.483333) console.log(`Partial hour: ${partialHour}`);
  const minutes = Number((Math.round(partialHour * 60) / 60).toFixed(4));
  if (combinedTime == 12.483333) console.log(`minutes: ${minutes}`);
  return hours + Number((Math.round(minutes * 100) / 100).toFixed(2));
}

export function GetDayList(startDate: Dayjs, endDate: Dayjs) {
  const response = Array<Dayjs>();
  let currentDate = SDate.new(startDate);
  while (currentDate.isSameOrBefore(endDate)) {
    response.push(SDate.new(currentDate));
    currentDate = currentDate.add(1, 'day');
  }
  return response;
}

export function HasNoTime(selDate: Dayjs | undefined) {
  return selDate && selDate.hour() === 0 && selDate.minute() === 0 && selDate.second() === 1;
}

/*
export function Moment2Delay(duration: Dayjs): Duration {
  let currentDuration = SDuration.new(duration.local().diff(SDate.new().startOf('day')));
  if (currentDuration.years() > 0) {
    console.log(`Subtracting Year: ${currentDuration.years()} From ${currentDuration.toISOString()}`);
    currentDuration = currentDuration.subtract(Math.trunc(currentDuration.years()), 'years');
    console.log(`Subtracting Months: ${currentDuration.months()} From ${currentDuration.toISOString()}`);
    currentDuration = currentDuration.subtract(currentDuration.months(), 'months');
    console.log(`Subtracting Day: 1 From ${currentDuration.toISOString()}`);
    currentDuration = currentDuration.subtract(1, 'day');
  }
  currentDuration = currentDuration.subtract(Math.trunc(currentDuration.get('seconds')), 'seconds');
  currentDuration = currentDuration.subtract(Math.trunc(currentDuration.get('milliseconds')), 'milliseconds');
  console.log(`Duration: ${duration.toISOString()} -> ${currentDuration.toISOString()}`);
  console.log(
    `Duration: ${Math.trunc(currentDuration.asDays())}:${currentDuration.hours()}:${currentDuration.minutes()}`
  );
  return currentDuration;
}
*/
